import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";

const Error404Page = () => {
  return (
    <>
      <Container
        className="error-container text-center"
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Row
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Col>
            <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
              <h1 className="error-title" style={{ color: "#FF0000" }}>
                Error 404
              </h1>
              <p className="error-message" style={{ color: "#6C6C6C" }}>
                Oops! The page you're looking for does not exist.
              </p>
              <Link to="/">
                <Button
                  variant="primary"
                  className="home-link"
                  style={{ backgroundColor: "#FF0000", borderColor: "#FF0000" }}
                >
                  Go back to Home
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Error404Page;
